export default "__VITE_ASSET__wAWiY5Q5__"